<template>
  <div
    :class="['el-divider', `el-divider--${direction}`]"
    :style="{
      'background-image': styleMap[borderStyle],
      'background-size': '8px 1px',
      'background-repeat': 'repeat-x',
    }"
  >
    <div
      v-if="this.$slots.default && direction !== 'vertical'"
      :class="['el-divider__text', `is-${contentPosition}`]"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElDivider',
  props: {
    borderStyle: '',
    borderColor: '',
    direction: {
      type: String,
      default: 'horizontal',
      validator(val) {
        return ['horizontal', 'vertical'].indexOf(val) !== -1;
      }
    },
    contentPosition: {
      type: String,
      default: 'center',
      validator(val) {
        return ['left', 'center', 'right'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    styleMap() {
      return {
        'solid': `linear-gradient(to right, ${this.borderColor} 0%, ${this.borderColor} 50%, ${this.borderColor} 50%)`,
        'dashed': `linear-gradient(to right, ${this.borderColor} 0%, ${this.borderColor} 50%, transparent 50%)`,

      }
    }
  }

};

</script>

<style lang="scss">
.el-divider {
  // background-color: #dcdfe6;
  position: relative;
}
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 24px 0;
}
.el-divider--vertical {
  display: inline-block;
  width: 1px;
  height: 1em;
  margin: 0 8px;
  vertical-align: middle;
  position: relative;
}
.el-divider__text {
  position: absolute;
  background-color: #fff;
  padding: 0 20px;
  font-weight: 500;
  color: #303133;
  font-size: 14px;
}
.el-divider__text.is-left {
  left: 20px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.el-divider__text.is-center {
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}
.el-divider__text.is-right {
  right: 20px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>